import { HStack } from '@sgme/ui';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl';
import { getRateComponentStyling } from '@/utils/rateComponentStyling.ts';

import { RATES_CONTAINER_HEIGHT } from './constants.ts';

type LoadingRatesComponentProps = {
  canTrade: boolean;
  messageId?: IntlMessageId;
};

/**
 * Component displayed when rates are loading
 */
export const LoadingRatesComponent = ({
  canTrade,
  messageId = 'CashTile.SpotRates.loading',
}: LoadingRatesComponentProps) => (
  <HStack
    fullWidth
    horizontalAlignment="center"
    verticalAlignment="center"
    style={{ height: RATES_CONTAINER_HEIGHT }}
    className={clsx('px-2 py-1', ...getRateComponentStyling({ executable: false, cantTrade: !canTrade }))}
    data-e2e="loading-rates"
  >
    <FormattedMessage id={messageId} />
  </HStack>
);
